
import FAQAccordion from '../../../components/base/FAQAccordion';
import { homeFaqs } from '../../../mocks/faqs';

const FAQSection = () => {
  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="font-serif text-4xl md:text-5xl font-bold text-charcoal mb-4">
              Frequently Asked Questions
            </h2>
            <div className="w-16 h-1 bg-primary mx-auto mb-6"></div>
            <p className="text-gray-600 text-lg">
              Everything you need to know about our bakkie removals and landscaping services in Durban and KZN
            </p>
          </div>

          <FAQAccordion faqs={homeFaqs} />

          <div className="mt-12 text-center bg-greenbg rounded-2xl p-8">
            <h3 className="font-bold text-2xl text-charcoal mb-4">Still Have Questions?</h3>
            <p className="text-gray-700 mb-6">
              Contact us directly via WhatsApp, phone, or email. We're here to help with all your removal and landscaping needs.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 justify-center">
              <a
                href="https://wa.me/27798768956"
                target="_blank"
                rel="noopener noreferrer"
                className="bg-primary text-white px-8 py-3 rounded-full font-semibold hover:bg-primary-dark transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-whatsapp-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                WhatsApp Us
              </a>
              <a
                href="tel:+27798768956"
                className="bg-white text-primary border-2 border-primary px-8 py-3 rounded-full font-semibold hover:bg-primary hover:text-white transition-colors whitespace-nowrap cursor-pointer"
              >
                <i className="ri-phone-line mr-2 w-5 h-5 flex items-center justify-center"></i>
                Call 079 876 8956
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
